export default {
  checkInterval: 'Prüfintervall',
  newCommitCheckInterval: 'Prüfintervall für neue Commits',
  schedule: 'Zeitplan',
  newSchedule: 'Neuer Zeitplan',
  deleteSchedule: 'Zeitplan löschen',
  editSchedule: 'Zeitplan bearbeiten',
  backup: 'Projekt-Backup',
  downloadTheProjectBackupFile: 'Projekt-Backup-Datei herunterladen.',
  restoreProject: 'Projekt wiederherstellen...',
  incorrectUsrPwd: 'Falscher Login oder falsches Passwort',
  askDeleteUser: 'Möchten Sie diesen Benutzer wirklich löschen?',
  askDeleteTemp: 'Möchten Sie diese Vorlage wirklich löschen?',
  askDeleteEnv: 'Möchten Sie diese Variable-Gruppe wirklich löschen?',
  askDeleteInv: 'Möchten Sie dieses Inventory wirklich löschen?',
  askDeleteKey: 'Möchten Sie diesen Schlüssel wirklich löschen?',
  askDeleteRepo: 'Möchten Sie dieses Repository wirklich löschen?',
  askDeleteProj: 'Möchten Sie dieses Projekt wirklich löschen?',
  askDeleteTMem: 'Möchten Sie dieses Teammitglied wirklich löschen?',
  askDeleteSchedule: 'Möchten Sie diesen Zeitplan wirklich löschen?',
  edit: 'Bearbeiten',
  nnew: 'Neu',
  keyFormSshKey: 'SSH-Schlüssel',
  keyFormLoginPassword: 'Login mit Passwort',
  keyFormNone: 'Keine',
  incorrectUrl: 'Ungültige URL',
  username: 'Benutzername',
  username_required: 'Benutzername ist erforderlich',
  dashboard: 'Dashboard',
  history: 'Verlauf',
  activity: 'Aktivität',
  settings: 'Einstellungen',
  signIn: 'Anmelden',
  password: 'Passwort',
  changePassword: 'Passwort ändern',
  editUser: 'Benutzer bearbeiten',
  newProject: 'Neues Projekt',
  close: 'Schließen',
  newProject2: 'Neues Projekt...',
  demoMode: 'DEMO-MODUS',
  task: 'Task #{expr}',
  youCanRunAnyTasks: 'Sie können beliebige Tasks ausführen',
  youHaveReadonlyAccess: 'Sie haben nur Lesezugriff',
  taskTemplates: 'Task-Vorlagen',
  inventory: 'Inventory',
  environment: 'Variablengruppen',
  keyStore: 'Schlüsselspeicher',
  repositories: 'Repositories',
  darkMode: 'Dunkelmodus',
  team: 'Team',
  users: 'Benutzer',
  editAccount: 'Konto bearbeiten',
  signOut: 'Abmelden',
  error: 'Fehler',
  refreshPage: 'Seite neu laden',
  relogin: 'Neu anmelden',
  howToFixSigninIssues: 'Wie man Anmeldeprobleme behebt',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: 'Zuerst benötigen Sie Zugriff auf den Server, auf dem Semaphore läuft.',
  executeTheFollowingCommandOnTheServerToSeeExisting: 'Führen Sie folgenden Befehl auf dem Server aus, um vorhandene Benutzer zu sehen:',
  semaphoreUserList: 'semaphore user list',
  youCanChangePasswordOfExistingUser: 'Sie können das Passwort eines bestehenden Benutzers ändern:',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: 'Oder erstellen Sie einen neuen Admin-Benutzer:',
  close2: 'Schließen',
  semaphore: 'SEMAPHORE',
  dontHaveAccountOrCantSignIn: 'Kein Konto oder Anmeldung nicht möglich?',
  password2: 'Passwort',
  cancel: 'Abbrechen',
  noViews: 'Keine Ansichten',
  addView: 'Ansicht hinzufügen',
  editEnvironment: 'Variablengruppe bearbeiten',
  deleteEnvironment: 'Variablengruppe löschen',
  newEnvironment: 'Neue Gruppe',
  environmentName: 'Gruppenname',
  dockerImage: 'Runner Docker Image (optional)',
  extraVariables: 'Zusätzliche Variablen',
  enterExtraVariablesJson: 'Zusätzliche Variablen als JSON eingeben...',
  environmentVariables: 'Umgebungsvariablen',
  enterEnvJson: 'Env JSON eingeben...',
  environmentAndExtraVariablesMustBeValidJsonExample: 'Variablen müssen gültiges JSON sein. Beispiel:',
  dashboard2: 'Dashboard',
  ansibleSemaphore: 'Semaphore UI',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor:
    'JavaScript ist deaktiviert. Bitte aktivieren Sie es für die vollständige Funktionalität.',
  deleteInventory: 'Inventory löschen',
  newInventory: 'Neues Inventory',
  name: 'Name',
  userCredentials: 'Benutzer-Credentials',
  sudoCredentialsOptional: 'Sudo-Credentials (optional)',
  type: 'Typ',
  pathToInventoryFile: 'Pfad zur Inventory-Datei',
  enterInventory: 'Inventory eingeben...',
  staticInventoryExample: 'Beispiel statisches Inventory:',
  staticYamlInventoryExample: 'Beispiel statisches YAML-Inventory:',
  keyName: 'Schlüsselname',
  loginOptional: 'Login (optional)',
  usernameOptional: 'Benutzername (optional)',
  privateKey: 'Privater Schlüssel',
  override: 'Überschreiben',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook:
    'Verwenden Sie diesen Schlüsselt-Typ für HTTPS-Repositories und Playbooks ohne SSH-Verbindungen.',
  deleteKey: 'Schlüssel löschen',
  newKey: 'Neuer Schlüssel',
  create: 'Erstellen',
  newTask: 'Neuer Task',
  cantDeleteThe: '{objectTitle} kann nicht gelöscht werden',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow:
    '{objectTitle} kann nicht gelöscht werden, da es von folgenden Ressourcen verwendet wird',
  projectName: 'Projektname',
  allowAlertsForThisProject: 'Benachrichtigungen für dieses Projekt erlauben',
  telegramChatIdOptional: 'Telegram Chat ID (optional)',
  maxNumberOfParallelTasksOptional: 'Max. Anzahl paralleler Tasks (optional)',
  deleteRepository: 'Repository löschen',
  newRepository: 'Neues Repository',
  urlOrPath: 'URL oder Pfad',
  absPath: 'Absoluter Pfad',
  branch: 'Branch',
  accessKey: 'Zugangsschlüssel',
  credentialsToAccessToTheGitRepositoryItShouldBe: 'Zugangsdaten zum Git Repository. Dies sollte sein:',
  ifYouUseGitOrSshUrl: 'wenn Sie Git- oder SSH-URL verwenden.',
  ifYouUseHttpsOrFileUrl: 'wenn Sie HTTPS- oder Datei-URL verwenden.',
  none: 'Keine',
  ssh: 'SSH',
  deleteProject: 'Projekt löschen',
  save: 'Speichern',
  deleteProject2: 'Projekt löschen',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer:
    'Nach dem Löschen eines Projektes gibt es kein Zurück. Bitte seien Sie sicher.',

  clear_cache: 'Cache leeren',
  clear_cache_message: 'Alle Cache-Dateien für dieses Projekt löschen. Diese Aktion ist irreversibel.',

  name2: 'Name *',
  title: 'Titel *',
  description: 'Beschreibung',
  required: 'Erforderlich',
  key: '{expr}',
  surveyVariables: 'Survey-Variablen',
  addVariable: 'Variable hinzufügen',
  vaultName: 'Vault ID (optional)',
  vaultNameDefault: 'Nur ein `default` Name (leer) erlaubt',
  default_value: 'Standardwert',
  vaultNameUnique: 'Muss eindeutig sein',
  vaultTypePassword: 'Passwort',
  vaultTypeScript: 'Client-Skript',
  vaultScript: 'Skriptpfad',
  vaultScriptRequired: 'Skriptpfad ist erforderlich',
  vaultScriptClientRequired: 'Skriptpfad muss mit "-client" und Dateiendung enden',
  vaults: 'Vaults',
  vaultAdd: 'Vault hinzufügen',
  vaultRequired: 'Vault-Passwort ist erforderlich',
  columns: 'Spalten',
  buildVersion: 'Build-Version',
  messageOptional: 'Nachricht (optional)',
  debug: 'Debug',
  dryRun: 'Testlauf',
  diff: 'Diff',
  advanced: 'Erweitert',
  hide: 'Ausblenden',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett:
    'Erlauben Sie das Überschreiben von CLI-Argumenten in den Task-Template-Einstellungen.',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe:
    'CLI-Argumente (JSON Array). Beispiel: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Gestartet',
  author: 'Autor',
  duration: 'Dauer',
  stop: 'Stoppen',
  forceStop: 'Erzwingen',
  raw_log: 'Roh-Log',

  confirmTask: 'Bestätigen',
  deleteTeamMember: 'Teammitglied löschen',
  team2: 'Team',
  newTeamMember: 'Neues Teammitglied',
  user: 'Benutzer',
  administrator: 'Administrator',
  definesStartVersionOfYourArtifactEachRunIncrements: 'Definiert die Startversion des Artefakts. Jeder Lauf erhöht die Version.',
  forMoreInformationAboutBuildingSeeThe: 'Weitere Informationen zum Build finden Sie in der',
  taskTemplateReference: 'Task Template Referenz',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: 'Definiert, welches Artefakt beim Task ausgeführt wird.',
  forMoreInformationAboutDeployingSeeThe: 'Weitere Informationen zum Deployment finden Sie in der',
  taskTemplateReference2: 'Task Template Referenz',
  definesAutorunSchedule: 'Definiert den automatischen Ausführungszeitplan',
  forMoreInformationAboutCronSeeThe: 'Mehr über Cron erfahren:',
  cronExpressionFormatReference: 'Referenz für das Cron-Ausdrucksformat',
  startVersion: 'Startversion',
  example000: 'Beispiel: 0.0.0',
  buildTemplate: 'Build-Vorlage',
  autorun: 'Auto-Run',
  playbookFilename: 'Pfad zur Playbook-Datei *',
  exampleSiteyml: 'Beispiel: deploy/site.yml',
  inventory2: 'Inventory *',
  repository: 'Repository',
  environment3: 'Variablengruppe *',
  vaultPassword: 'Vault-Passwort',
  vaultPassword2: 'Vault-Passwort',
  view: 'Ansicht',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: 'Ich möchte einen Task per Cron nur für neue Commits eines Repositories ausführen',
  repository2: 'Repository',
  cronChecksNewCommitBeforeRun: 'Cron prüft neue Commits vor der Ausführung',
  readThe: 'Lesen Sie die',
  toLearnMoreAboutCron: 'um mehr über Cron zu erfahren.',
  suppressSuccessAlerts: 'Erfolgsbenachrichtigungen unterdrücken',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2:
    'CLI-Argumente (JSON Array). Beispiel: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'CLI-Argumente',
  docs: 'Dokumentation',
  editViews: 'Ansichten bearbeiten',
  newTemplate: 'Neue Vorlage',
  taskTemplates2: 'Task-Vorlagen',
  all: 'Alle',
  notLaunched: 'Nicht gestartet',
  by: 'von {user_name}',
  editTemplate: 'Vorlage bearbeiten',
  newTemplate2: 'Neue Vorlage',
  deleteTemplate: 'Vorlage löschen',
  playbook: 'Playbook',
  email: 'E-Mail',
  adminUser: 'Admin-Benutzer',
  sendAlerts: 'Benachrichtigungen senden',
  deleteUser: 'Benutzer löschen',
  newUser: 'Neuer Benutzer',
  re: 'Re{getActionButtonTitle}',
  teamMember: '{expr} Teammitglied',
  taskId: 'Task-ID',
  version: 'Version',
  status: 'Status',
  start: 'Start',
  actions: 'Aktionen',
  alert: 'Benachrichtigungen',
  admin: 'Admin',
  role: 'Rolle',
  external: 'Extern',
  time: 'Zeit',
  path: 'Pfad',
  gitUrl: 'Git-URL',
  sshKey: 'SSH-Schlüssel',
  lastTask: 'Letzter Task',
  task2: 'Task',
  build: 'Build',
  deploy: 'Deployment',
  run: 'Ausführen',
  add: 'Hinzufügen',
  password_required: 'Passwort ist erforderlich',
  name_required: 'Name ist erforderlich',
  user_credentials_required: 'Benutzer-Credentials erforderlich',
  type_required: 'Typ ist erforderlich',
  path_required: 'Pfad zur Inventory-Datei ist erforderlich',
  private_key_required: 'Privater Schlüssel ist erforderlich',
  project_name_required: 'Projektname ist erforderlich',
  repository_required: 'Repository ist erforderlich',
  branch_required: 'Branch ist erforderlich',
  key_required: 'Schlüssel ist erforderlich',
  user_required: 'Benutzer ist erforderlich',
  build_version_required: 'Build-Version ist erforderlich',
  title_required: 'Titel ist erforderlich',
  isRequired: 'ist erforderlich',
  mustBeInteger: 'Muss eine ganze Zahl sein',
  mustBe0OrGreater: 'Muss >= 0 sein',
  start_version_required: 'Startversion ist erforderlich',
  playbook_filename_required: 'Playbook-Dateiname ist erforderlich',
  inventory_required: 'Inventory ist erforderlich',
  environment_required: 'Variablengruppe ist erforderlich',
  email_required: 'E-Mail ist erforderlich',
  build_template_required: 'Build-Vorlage ist erforderlich',
  Task: 'Task',
  Build: 'Build',
  Deploy: 'Deployment',
  Run: 'Ausführen',
  ReBuild: 'Neu Builden',
  ReDeploy: 'Neu Deployen',
  ReRun: 'Erneut Ausführen',
  CreateDemoProject: 'Demo-Projekt erstellen',
  LeaveProject: 'Projekt verlassen',
  integration: 'Integration',
  integrations: 'Integrationen',
  NewIntegration: 'Neue Integration',
  EditIntegration: 'Integration bearbeiten',
  DeleteIntegration: 'Integration löschen',
  DeleteIntegrationMsg: 'Möchten Sie diese Integration wirklich löschen?',
  AddAlias: 'Alias hinzufügen',
  LoadAlias: 'Lade Aliase...',
  globalAlias: 'Projektalias verwenden',
  matcher: 'Matcher',
  matchType: 'Vergleichstyp',
  newMatcher: 'Neuer Matcher',
  matchMethod: 'Vergleichsmethode',
  matchBodyDataType: 'Body-Datentyp',
  extractValue: 'Wert extrahieren',
  newExtractedValue: 'Neuer extrahierter Wert',
  extractedValueSource: 'Wertquelle',
  matchKey: 'Schlüssel',
  matchValue: 'Wert',
  matchOn: 'Vergleichen mit',
  runners: 'Runner',
  newRunner: 'Neuer Runner',
  enabled: 'Aktiviert',
  scheduleNextRun: 'Nächster Lauf',
  maxNumberOfParallelTasks: 'Max. parallele Tasks',
  runnerUsage: 'Benutzung:',
  runnerDockerCommand: 'Docker:',
  runnerToken: 'Token:',
  editRunner: 'Runner bearbeiten',
  deleteRunner: 'Runner löschen',
  newRunnerToken: 'Neuer Runner',
  askDeleteRunner: 'Möchten Sie Runner {runner} wirklich löschen?',
  roles_only_enterprise: 'Rollen sind nur in der <b>Enterprise</b>-Edition verfügbar.',
  project_runners_only_pro: 'Projektbezogene Runner sind nur für <b>PRO</b>-Benutzer verfügbar.',
  secret_storage_only_pro: 'Secret-Speicher sind nur für <b>PRO</b>-Benutzer verfügbar.',
  foss_runners_limited: 'Die Open-Source-Version ist eingeschränkt. Volle Funktionen in der <b>PRO</b>-Version.',
  learn_more_about_pro: 'Mehr erfahren',
  upgrade_to_pro: 'Upgrade',
  contact_admin_to_upgrade: 'Wenden Sie sich an Ihren Admin, um PRO-Funktionen zu aktivieren.',
  contact_admin_to_upgrade_enterprise: 'Wenden Sie sich an Ihren Admin, um Enterprise-Funktionen zu aktivieren.',

  projectRestoreResult: 'Ergebnis der Projekt-Wiederherstellung',
  projectWithNameRestored: 'Projekt {projectName} erfolgreich wiederhergestellt.',
  pleaseUpdateAccessKeys: 'Bitte aktualisieren Sie diese vor dem Ausführen von Tasks.',
  emptyKeysRestored: '{emptyKeys} leere Schlüssel hinzugefügt.',
  template: 'Vorlage',
  aliasUrlCopied: 'Alias-URL wurde in die Zwischenablage kopiert.',
  yes: 'Ja',
  activeTasks: 'Aktive Tasks',
  taskLocation: 'Ort',
  empty: 'Leer',
  noValues: 'Keine Werte',
  addArg: 'Argument hinzufügen',

  status_success: 'Erfolgreich',
  status_failed: 'Fehlgeschlagen',
  status_stopped: 'Gestoppt',

  api_tokens: 'API-Tokens',

  // Terraform/OpenTofu/Terragrunt
  auto_approve: 'Auto-Akzeptieren',
  auto_destroy: 'Löschen erlauben',
  terraform_override_backend: 'Backend-Einstellungen überschreiben',
  terraform_backend_filename: 'Backend-Dateiname (Standard: backend.tf)',
  terraform_invalid_backend_filename: 'Ungültiger Backend-Dateiname',

  // Ansible
  tag: 'Tag',
  tag_required: 'Tag ist erforderlich',
  allowInventoryInTask: 'Inventory',
  allowLimitInTask: 'Limit',
  addLimit: 'Limit hinzufügen',
  allowDebug: 'Debug erlauben',
  addTag: 'Tag hinzufügen',
  skipTags: 'Tags überspringen',
  addSkippedTag: 'Übersprungenen Tag hinzufügen',
  tags: 'Tags',
  limit: 'Limit',

  runner_tag: 'Runner-Tag',
  allow_parallel_tasks: 'Parallele Tasks erlauben',
  task_prompts: 'Prompts',
  template_advanced: 'Erweiterte Optionen',
  template_app_options: '{app}-Optionen',
  template_app_prompts: '{app}-Prompts',
  general_settings: 'Allgemein',
  danger_zone_settings: 'Gefahrenzone',
  project_stats: 'Statistiken',
  allow_override_branch: 'Branch überschreiben',
  template_common_options: 'Allgemeine Optionen',

  template_tasks: 'Tasks',
  template_details: 'Details',
  template_tf_workspaces: 'Workspaces',

  // Rollen
  slug: 'Slug',
  slug_required: 'Slug ist erforderlich',
  slugHint: 'Eindeutige ID (kleinbuchstaben, alphanumerisch, Unterstrich/Bindestrich erlaubt)',
  invalidSlugFormat:
    'Slug muss kleingeschrieben, alphanumerisch und mit Unterstrichen/Bindestrichen sein',
  permissions: 'Berechtigungen',
  canRunProjectTasks: 'Kann Projekt-Tasks ausführen',
  canUpdateProject: 'Kann Projekt aktualisieren',
  canManageProjectResources: 'Kann Ressourcen verwalten',
  canManageProjectUsers: 'Kann Benutzer verwalten',
  newRole: 'Neue Rolle',
  editRole: 'Rolle bearbeiten',
  deleteRole: 'Rolle löschen',
  askDeleteRole: 'Möchten Sie diese Rolle wirklich löschen?',
  Roles: 'Rollen',
  role_required: 'Rolle ist erforderlich',

  templatePermission: 'Vorlagenrechte',
};
